import { useState } from 'react';
import profiles from '../../../config/profiles.json';
import CRM from '../../../services/API/CRM.js';
import Loader from '../../Tools/Loader';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../Frames/Layout'
import FormButtons from '../../Inputs/FormButtons';
import { Button, Stack, Alert, TextField, MenuItem, Box, Typography } from '@mui/material';
import Phone from '../../Inputs/Phone';
import CategorySelect from '../../Inputs/CategorySelect';
import Rpps from '../../Inputs/Rpps'
import Siret from '../../Inputs/Siret';
import Address from '../../Inputs/Address';
import Password from '../../Inputs/Password';
import useJsonStore from '../../../services/Hooks/useJsonStore.js';
import Status from '../../Inputs/Status';


export default function PersonForm(){

    const {id} = useParams();
    const navigate = useNavigate();

    const store = useJsonStore();

    const [data, setData] = useState(false);
    const [password, setPassword] = useState(false);


    useEffect(() => {

        if(id === 'new'){

            let defaultData = {
                profile: {id: 'student'},
                category: {},
                status: {},
                origin: {id: 'crm'},
                country: 'FR',
                phone: '+33',
                phone2: '+33',
                subscription: {id: 'none'}
            };

            let prospect = store.get('prospectToUser');

            console.log('prospect', prospect);

            if(prospect){
                Object.assign(defaultData, prospect);
                delete defaultData.id;
                defaultData.prospect = prospect;
                store.remove('prospectToUser');
            }

            setData(defaultData)

        }else{

            CRM.getPerson(id)
                .then(r => setData(r.data))
                .catch(e => console.log(e.response.data))

        }

    }, [id, store])

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false);

    const handleChange = (key, val) => {
        let copy = {...data};
        copy[key] = val;
        return setData(copy);
    }

    const handleSubmit = e => {
        e.preventDefault();

        if( !isValid() ) return false;

        if(!password) delete data.password;

        (id === 'new' ? CRM.postPerson(data) : CRM.putPerson(id, data))
            .then(r => handleSuccess(r.data))
            .catch(e => handleError(e))

        setError(false);
        return setLoading(true);
    }

    const handleSuccess = data => {
        console.log(data);
        const key = id !== 'new' ? id : data.id;
        return navigate(`/crm/persons/${key}`);
    }

    const handleError = e => {
        let err;
        if(e.response.status === 409) err = "Cette adresse email est déjà utilisée";
        setError(err);
        return setLoading(false);
    }

    const isValid = () => {
        let e = false;

        if(data.password && data.password.length < 8 ) e = "Le mot de passe doit comporter au moins 8 caractères";

        setError(e);
        return !e;
    }


    return <Layout tab='persons' menu='crm'>
    
        {data && <form onSubmit={handleSubmit} style={{margin: '20px 0px'}}>

            <Stack direction='column' spacing={3} sx={{maxWidth: 600, margin: 'auto'}}>

                <Typography variant='h1'>Profil utilisateur</Typography>

                {error && <Alert severity='error'>{error}</Alert>}

                <TextField
                    label='Nom'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.lastName || ''}
                    onChange={e => handleChange('lastName', e.target.value)}
                />

                <TextField
                    label='Prénom'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.firstName || ''}
                    onChange={e => handleChange('firstName', e.target.value)}
                />

                <TextField
                    label='Email'
                    type='email'
                    inputProps={{minLength: 2, maxLength: 250}}
                    required 
                    size='small'
                    value={data.email|| ''}
                    onChange={e => handleChange('email', e.target.value)}
                />

                <Phone
                    value={data.phone || ''}
                    country={data.country}
                    onChange={(phone, country) => setData({...data, phone, country})}
                    hideCountry
                />

                <Phone
                    value={data.phone2 || ''}
                    country={data.country}
                    onChange={(phone, country) => setData({...data, phone2: phone, country})}
                    hideCountry
                />

                <CategorySelect 
                    value={data.category?.id || ''}
                    onChange={id => handleChange('category', {id})}
                    required
                />

                <Status
                    category={data.category?.id}
                    value={data.status}
                    onChange={status => handleChange('status', status)}
                    required
                />

                <Rpps
                    value={data.rpps}
                    onChange={value => handleChange('rpps', value)}
                />

                <Siret
                    value={data.siret}
                    onChange={value => handleChange('siret', value)}
                />

                <TextField
                    label="Effectif de l'entreprise"
                    type='number'
                    inputProps={{min: 0}}
                    size='small'
                    value={data.workforce || ''}
                    onChange={e => handleChange('workforce', e.target.value)}
                />

                <TextField
                    label='Abonnement'
                    select
                    required
                    size='small'
                    value={data.subscription?.id || 'none'}
                    onChange={e => handleChange('subscription', {id: e.target.value})}
                >
                    <MenuItem value='none'>Aucun</MenuItem>
                    <MenuItem value='plus'>LearnyLib +</MenuItem>
                    <MenuItem value='pro'>LearnyLib Pro</MenuItem>
                </TextField>


                <Address
                    value={data}
                    onChange={data => setData(data)}
                />


                <TextField
                    label='Profil'
                    select
                    required
                    size='small'
                    value={data.profile?.id || ''}
                    onChange={e => handleChange('profile', {id: e.target.value})}
                >
                    {profiles.filter(p => p.id !== 'admin')
                        .map(p => 
                            <MenuItem key={p.id} value={p.id}>{p.title}</MenuItem>
                        )
                    }
                </TextField>
                

                {password && 
                    <Password
                        value={data.password || ''}
                        onChange={e => handleChange('password', e.target.value)}
                    />
                }

                <Box>{!password ?
                    <Button onClick={() => setPassword(true)}>Configurer le mot de passe</Button>
                    :
                    <Button onClick={() => setPassword(false)}>Ne pas configurer le mot de passe</Button>
                }</Box>
                
                <FormButtons
                    loading={loading}
                    onCancel={() => navigate(-1)}
                />

            </Stack>
                
        </form>}

        {!data && <Loader />}

    </Layout>
}

